import React from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "../lib/api";
import { useSettings } from "../contexts/SettingsContext";
import { CheckCircle2, XCircle, Loader2, Mail } from "lucide-react";

export default function Unsubscribe() {
    const [sp] = useSearchParams();
    const { settings } = useSettings();
    const token = sp.get("token") || "";
    const emailParam = sp.get("email") || "";
    const [state, setState] = React.useState(token || emailParam ? "loading" : "manual");
    const [message, setMessage] = React.useState("");
    const [emailInput, setEmailInput] = React.useState(emailParam);

    const company = settings?.site_name || settings?.company_name || "ccashop";

    const doUnsub = React.useCallback(async (payload) => {
        setState("loading");
        try {
            const r = await api.post("/newsletter/unsubscribe", payload);
            setMessage(r.data?.message || "Te-ai dezabonat cu succes.");
            setState("success");
        } catch (e) {
            setMessage(e.response?.data?.detail || "Eroare la dezabonare. Te rugăm să încerci din nou.");
            setState("error");
        }
    }, []);

    React.useEffect(() => {
        if (token) doUnsub({ token });
        else if (emailParam) doUnsub({ email: emailParam });
    }, [token, emailParam, doUnsub]);

    const submitManual = (e) => {
        e.preventDefault();
        if (!emailInput.trim()) return;
        doUnsub({ email: emailInput.trim() });
    };

    return (
        <div className="min-h-[70vh] flex items-center justify-center px-4 py-16 bg-background" data-testid="unsubscribe-page">
            <div className="max-w-md w-full card-soft p-8 text-center">
                <div className="flex justify-center mb-4">
                    {state === "loading" && <Loader2 className="h-12 w-12 text-primary animate-spin" />}
                    {state === "success" && <CheckCircle2 className="h-12 w-12 text-emerald-600" />}
                    {state === "error" && <XCircle className="h-12 w-12 text-destructive" />}
                    {state === "manual" && <Mail className="h-12 w-12 text-primary" />}
                </div>
                <h1 className="font-heading text-2xl mb-2">
                    {state === "success" ? "Dezabonat cu succes" : state === "error" ? "Nu am putut dezabona" : state === "loading" ? "Se procesează..." : "Dezabonare newsletter"}
                </h1>
                <p className="text-sm text-muted-foreground mb-6" data-testid="unsubscribe-message">
                    {state === "manual" && `Introdu adresa de email pentru a te dezabona de la newsletter-ul ${company}.`}
                    {state === "loading" && "Te rugăm să aștepți..."}
                    {(state === "success" || state === "error") && message}
                </p>

                {state === "manual" && (
                    <form onSubmit={submitManual} className="space-y-3">
                        <input type="email" required value={emailInput} onChange={(e) => setEmailInput(e.target.value)}
                               placeholder="adresa@email.ro" className="input-soft w-full" data-testid="unsubscribe-email-input" />
                        <button type="submit" className="btn-primary w-full" data-testid="unsubscribe-submit">Dezabonare</button>
                    </form>
                )}
                {state === "error" && (
                    <button onClick={() => setState("manual")} className="btn-outline w-full" data-testid="unsubscribe-retry">Încearcă cu alt email</button>
                )}
                {state === "success" && (
                    <p className="text-xs text-muted-foreground mt-4">
                        Ne pare rău că pleci! Dacă te răzgândești, te poți reînregistra oricând la newsletter-ul nostru.
                    </p>
                )}
                <div className="mt-6 pt-6 border-t border-border">
                    <Link to="/" className="text-sm text-primary hover:underline" data-testid="unsubscribe-home-link">← Înapoi la {company}</Link>
                </div>
            </div>
        </div>
    );
}
